<template>
  <v-app style="background-color:white">
    <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

    <v-card class="form-container" flat style="margin-top:-10px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap>
            <v-flex xs12 sm12 md6 style="padding-right:5px">
                <v-text-field v-model="form.itemName" label="Item Name *" :rules="emptyRule" required></v-text-field>
            </v-flex>
            <v-flex xs12 md4 sm12 style="padding-right:5px">
            <v-autocomplete
              v-model="selectedCategory"
              :items="categories"
              color="primary"
              label="Select Category *"
              item-text="categoryName"
              item-value="id"
              :rules="emptyRule" 
              required
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 md2 sm12>
            <v-autocomplete
              v-model="selectedUom"
              :items="uoms"
              color="primary"
              label="UOM *"
              item-text="UomName"
              item-value="Id"
              :rules="emptyRule" 
              required
            ></v-autocomplete>
          </v-flex>
          
          <v-flex xs12 sm12 md2 style="padding-right:5px">
            <v-text-field type="Number" v-model="form.mrp" label="MRP"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md2 style="padding-right:5px">
            <v-text-field type="Number" v-model="form.dp" label="DP"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md3 style="padding-right:5px">
            <v-text-field type="Number" v-model="form.purchaseRate" label="Purchase Rate"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md3 style="padding-right:5px">
            <v-text-field type="Number" v-model="form.saleRate" label="Sale Rate"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md2>
            <v-text-field type="Number" v-model="form.discount" label="Discount"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-autocomplete
              v-model="selectedHsn"
              :items="hsns"
              color="primary"
              label="Select HSN Code *"
              item-text="code"
              item-value="id"
              :rules="emptyRule" 
              required
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12>
            <b-form-checkbox v-model="form.show" >Set as featured product</b-form-checkbox>
          </v-flex>
          <v-flex xs12>
            <v-textarea v-model="form.description" label="Description"></v-textarea>
          </v-flex>
          
          <v-flex xs12 sm12 md12 style="text-align:right">
            <v-btn depressed color="#e53935" dark @click="back()">Cancel</v-btn>
            <v-btn depressed :loading="btnSave" color="primary" dark @click="onSubmit()">Save </v-btn>
          </v-flex>
          
        </v-layout>
      </v-form>
    </v-card>
  </v-app>
</template>

<script>
import config from "../../config.json";
export default {
  data() {
    return {
      dialog: false,
      entries: [],
      isLoading: false,
      model: null,
      search: null,
      btnSave: false,

      date1: new Date(),

      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
      },
      valid: true,
      roleType: sessionStorage.roles,
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/_"
        },
        {
          text: "Product",
          disabled: false,
          to: "/item"
        },
        {
          text: "Create",
          disabled: true,
          to: "/createStudent"
        }
      ],

      categories: [],
      selectedCategory: null,

      uoms: null,
      selectedUom: null,

      hsns: null,
      selectedHsn: null,
     
      form: {
          itemName: null,
          mrp: 0,
          dp: 0,
          purchaseRate: 0,
          saleRate: 0,
          discount: 0,
          show: false,
          description: null
      }
    };
  },

  mounted() {
      this.axios
        .get(config.API + "Categories", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.categories = res.data;
          this.$Progress.finish();
        });

        this.axios
        .get(config.API + "Uoms", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.uoms = res.data;
          this.$Progress.finish();
        });

        this.axios
        .get(config.API + "HsnCodes", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.hsns = res.data;
          this.$Progress.finish();
        });
    },

  methods: {
    back() {
      this.$router.go(-1);
    },
    onSubmit() {
      if (this.$refs.form.validate() && this.form.mrp >= 0 && this.form.dp >= 0 && this.form.purchaseRate >= 0 && this.form.saleRate >= 0 && this.form.discount >= 0) {
        this.btnSave = true;
        let code = "CP" + this.date1.getFullYear() + this.date1.getMonth() + Math.floor(100000 + Math.random() * 900000);
        this.axios
          .post(
            config.API + `Products`,
            {
              code: code,
              itemName: this.form.itemName,
              categoryId: JSON.parse(this.selectedCategory),
              uomId: JSON.parse(this.selectedUom),
              mrp: JSON.parse(this.form.mrp),
              dp: JSON.parse(this.form.dp),
              purchaseRate: JSON.parse(this.form.purchaseRate),
              saleRate: JSON.parse(this.form.saleRate),
              discount: JSON.parse(this.form.discount),
              show: this.form.show,
              description: this.form.description,
              hsnId: JSON.parse(this.selectedHsn)
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Successfully added");
            this.$router.go(-1);
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    }
  }
};
</script>

<style>
.bckgrnd {
  background-color: #424242;
  background-size:cover !important;
}
</style>
